export const eliminarUndefined = (object, undefinedValues = {}, exclude = []) => {
    let objetcAux = {...object }; // Se rompe la referencia al objeto para evitar campos no controlados
    Object.keys(objetcAux).forEach(key => {
        if (objetcAux[key] === '' && undefinedValues.hasOwnProperty(key) && undefinedValues[key] === undefined && !exclude.includes(key)) {
            delete objetcAux[key];
        }
    });
    return objetcAux;
}